/**
 * Where Review Full Profile goes: Profile, or Recommendation Settings when a must-have the form
 * doesn't show drove the Settings mismatch (EN-1000). The widget and the header popover share it.
 */
export const reviewTarget = (metrics) => (metrics.settings_mismatch_outside_form
	? { name: 'job-board-search', query: { recommendationSettings: 1 } }
	: { name: 'profile' });
